import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  EnvironmentInput,
  EnvironmentResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: EnvironmentInput
  onSuccess?: () => void
  children?: (response: EnvironmentResponse) => ReactElement
}

const CreateAiEnvironmentRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CreateAiEnvironmentRequest
